import PropTypes from 'prop-types';
import aboutServiceAttributeShape from './aboutServiceAttributeShape';

const aboutServiceShape = {
  id: PropTypes.number.isRequired,
  attributes: PropTypes.shape(aboutServiceAttributeShape).isRequired,
};

export default aboutServiceShape;
